/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import M_logo from "../../assets/main logo M.png";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

import DocumentTitle from "../../utils/DocumentTitle.js";
import { isValidEmail } from "../../utils/validators.js";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import socket from "../../services/socket.js";

const Login = () => {
  DocumentTitle("Mangas.IO translator");

  const navigate = useNavigate();
  const [isLogedin, setIsLogedIn] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("login_token")) {
      navigate("/series");
      setIsLogedIn(true);
    }
  }, []);

  let [showHidePW, setShowHidePW] = useState(false);
  const showAndHidePW = () => setShowHidePW(!showHidePW);

  const [emailIsEmpty, setEmailIsEmpty] = useState(false);
  const [passwordIsEmpty, setPasswordIsEmpty] = useState(false);

  const formOnSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let credentials = new FormData(e.currentTarget);
    let email = credentials.get("email").toLowerCase();
    const isvalid = await isValidEmail(email);
    if (!isvalid) {
      toast.error("Please type a valid mail address format.");
      setLoading(false);
      return;
    }

    let password = credentials.get("mot_de_passe");

    setEmailIsEmpty(email === "");
    setPasswordIsEmpty(password === "");

    if (email && password && isvalid) {
      const sendLogin = { email: email, mot_de_passe: password };
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_HOST_API}/api/auth/login`,
          sendLogin
        );

        if (res.status === 200) {
          let user_id = res.data?.payload?.utilisateur?.id;

          const userRes = await axios.get(
            `${process.env.REACT_APP_HOST_API}/api/user/${user_id}`,
            {
              headers: { Authorization: res.data.token },
            }
          );

          if (userRes.status === 200) {
            setLoading(false);
            const userData = userRes.data;

            localStorage.setItem("login_token", res.data.token);
            localStorage.setItem(
              "login_user",
              JSON.stringify({
                username: userData.nom_utilisateur,
                email: userData.email,
                role: userData.role,
                id: userData._id,
                organisation: userData.organisation,
              })
            );

            // Connect the socket and send online status
            socket.connect();
            socket.emit("userConnected", userData._id, "series");

            navigate("/series");
          }
        }
      } catch (error) {
        toast.error("Adresse mail ou mot de passe incorrect");
        setLoading(false);
        console.error("Error login:", error.message);
      }
    }
  };

  if (!isLogedin) {
    return (
      <div className="login_container">
        <div className="left_side">
          <div className="img_M">
            <img src={M_logo} alt="MangasIO Logo" />
          </div>
          <div className="welcome_text">
            <h1>
              Hey 👋🏼 <br /> Welcome to Mangas.io Translator
            </h1>
          </div>
        </div>
        <div className="right_side">
          <div className="login_section">
            <>
              <h2>Log In</h2>
              <form className="login_form" onSubmit={formOnSubmit}>
                <input
                  type="text"
                  name="email"
                  id="email"
                  placeholder={
                    emailIsEmpty ? "Email is required" : "Email Address"
                  }
                  style={
                    emailIsEmpty
                      ? { border: "1px solid red" }
                      : { border: "1px solid #DCDCDC" }
                  }
                />
                <div className="password_block">
                  <input
                    type={showHidePW ? "text" : "password"}
                    name="mot_de_passe"
                    id="mot_de_passe"
                    placeholder={
                      passwordIsEmpty ? "Password is required" : "Password"
                    }
                    style={
                      passwordIsEmpty
                        ? { border: "1px solid red" }
                        : { border: "1px solid #DCDCDC" }
                    }
                  />
                  <span className="hide_password" onClick={showAndHidePW}>
                    {showHidePW ? <FaEye /> : <FaEyeSlash />}
                  </span>
                </div>
                <button type="submit" id="login_btn">
                  {loading && (
                    <AiOutlineLoading3Quarters className="login_spin" />
                  )}{" "}
                  Log In
                </button>
              </form>
            </>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
};

export default Login;
